import { render, staticRenderFns } from "./Urls.vue?vue&type=template&id=1fd6fb3c&scoped=true"
import script from "./Urls.vue?vue&type=script&lang=js"
export * from "./Urls.vue?vue&type=script&lang=js"
import style0 from "./Urls.vue?vue&type=style&index=0&id=1fd6fb3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd6fb3c",
  null
  
)

export default component.exports